import { Component, OnInit, OnDestroy } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../providers/api.service';
import { Subscription } from 'rxjs';
import { SM_CONSTANTS } from '../../shared/constants/sm-constants';
import { ITableColumnHeader } from '../../models/table-column-header';
import { AddServiceComponent } from 'src/app/shared/components/add-service/add-service.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from '../../providers/shared.service';
import { NavigationService } from '../../providers/navigation.service';
import { AddServiceTemplatesComponent } from '../../shared/components/add-service-templates/add-service-templates.component';

@Component({
  selector: 'sm-service-templates',
  templateUrl: './service-templates.component.html',
  styleUrls: ['./service-templates.component.scss']
})
export class ServiceTemplatesComponent implements OnInit, OnDestroy {
  entityHashId: string = '';
  clickEventSubscription: Subscription
  public loader: boolean = false;
  serviceList: any[] = [];
  private _apiSubscription: Subscription;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "service name",
      columnProperty: "serviceName"
    },
    {
      columnName: "description",
      columnProperty: "description"
    },
    
    {
      columnName: "approx time",
      columnProperty: "approxTime"
    },
    {
      columnName: "home rate",
      columnProperty: "home_rate"
    },
    
    {
      columnName: "shop rate",
      columnProperty: "shop_rate"
    }
  ];
  constructor(private _navService: NavigationService, private route: ActivatedRoute, private _apiService: ApiService, private _modelRef: MatDialog, private sharedService: SharedService) { 
    this._navService.hideSidebarAndNav = false;
    this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
      this.ngOnInit();
    })
    
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_SERVICE_TEMPLATES_RESULT){
        console.log(resData);
        // if(resData.result && resData.result != null){
        //   resData.result.forEach((element:any) => {
        //     this.serviceList.push(element)
        //   });
         
        // }
        this.serviceList = resData.result ? resData.result : [];
        this.serviceList.forEach(element => {
          if(element.home_rate == 0){
            element.home_rate = '-'
          }
          if(element.shop_rate == 0){
            element.shop_rate = '-'
          }
          // if(element.shopDiscountedPrice == null){
          //   element.shopDiscountedPrice = '-'
          // }
          // if(element.homeDiscountedPrice == null){
          //   element.homeDiscountedPrice = '-'
          // }
        })
        console.log( this.serviceList);
        // this.serviceList.forEach((item )=> {
        //   item.addressInfo = JSON.parse(item.addressInfo).address_line
        // })
            console.log( this.serviceList);
        
      }
      this.loader = false;
    });
    console.log(this.serviceList);
    
  }
  // private modelSubscription: Subscription = new Subscription();
  ngOnInit(): void {
    this.loader = true;
   
    // this._apiService.getServiceTemplates();
    // this.modelSubscription = this._modelRef.afterAllClosed.subscribe((data) => {
    //   this.loader = true;
    //   this._apiService.getServices(this.entityHashId)
    // });

  }

  onCreateNewService(){
this._modelRef.open(AddServiceTemplatesComponent, {
      width: '700px',
      data: {
        title: 'Add service template',
        type: SM_CONSTANTS.SERVICE_TEMPLATE_ADD,
        ref: this._modelRef,
      },
    });
  }

  deactivateService(rowvalue: any){
console.log(rowvalue);
let metadata = {
  serviceTypeInfo: {
    hash_id: rowvalue.hash_id,
    status: 7
  }
}

this._apiService.addServiceTemplate(metadata)

setTimeout(() => {
  this.ngOnInit();
}, 1500);

  }

  activateService(rowvalue:any){
    console.log(rowvalue);
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        status: 1
      }
    }
    
    this._apiService.addServiceTemplate(metadata)
    
    setTimeout(() => {
      this.ngOnInit();
    }, 1500);
  }

  deleteService(rowvalue:any){
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        isDelete: 1
      }
    }

    this._apiService.addServiceTemplate(metadata)
    
    setTimeout(() => {
      this.ngOnInit();
    }, 1500);
  }

  onEdit(rowvalue:any){
    this._modelRef.open(AddServiceTemplatesComponent, {
      width: '700px',
      data: {
        title: 'Add service template',
        type: SM_CONSTANTS.SERVICE_TEMPLATE_ADD,
        ref: this._modelRef,
        data: rowvalue,
      },
    });
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    // this.modelSubscription.unsubscribe();
  }


}
